import { AdminAppState, PlaceEntry } from '../../state';
import { getPlaceEntry } from './get-place-entry';

export const getPlace = (placeKey: string) => (
  state: AdminAppState,
): PlaceEntry['place'] => getPlaceEntry(placeKey)(state).place;
